import { makeStyles } from "@material-ui/core";
import { leftPadding, topPadding } from "../Consts";
export const useNavBarStyles = makeStyles(() => ({
    mobileDrawer: {
        width: leftPadding,
    },
    desktopDrawer: {
        width: leftPadding,
        top: topPadding,
        height: `calc(100% - ${topPadding}px)`,
    },
}));
export const useNavItemStyles = makeStyles((theme) => ({
    item: {
        display: "flex",
        paddingTop: 0,
        paddingBottom: 0,
    },
    button: {
        color: theme.palette.text.secondary,
        fontWeight: theme.typography.fontWeightMedium,
        justifyContent: "flex-start",
        letterSpacing: 0,
        padding: "10px 8px",
        textTransform: "none",
        width: "100%",
    },
    icon: {
        marginRight: theme.spacing(1),
    },
    title: {
        marginRight: "auto",
    },
    active: {
        color: theme.palette.primary.main,
        "& $title": {
            fontWeight: theme.typography.fontWeightMedium,
        },
        "& $icon": {
            color: theme.palette.primary.main,
        },
    },
}));
//# sourceMappingURL=styles.js.map